import { useState } from 'react';
import PropTypes from 'prop-types';
import { ClickAwayListener, IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

function BookMaterialModal({ contentBookNote }) {
  const [openModalBookNote, setOpenModalBookNote] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setOpenModalBookNote(false)}>
      <Tooltip
        leaveDelay={3000}
        leaveTouchDelay={3000}
        onClose={() => setOpenModalBookNote(false)}
        open={openModalBookNote}
        title={contentBookNote}
      >
        <IconButton
          color="primary"
          onClick={() => setOpenModalBookNote(true)}
          size="small"
        >
          <InfoIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
}

BookMaterialModal.propTypes = {
  contentBookNote: PropTypes.string,
};

BookMaterialModal.defaultProps = {
  contentBookNote: '',
};

export default BookMaterialModal;
